import _ from "lodash";

// Diagnosis table pagination
export const DIAGNOSIS_PAGE_SIZE = 7;

// Rows render primary-first, so mapping a row to its page must use this order.
export const diagnosisPrimarySorter = (a, b) => b.isPrimary - a.isPrimary;
export const orderDiagnosisRowsForDisplay = (rows) => [...rows].sort(diagnosisPrimarySorter);

/// Get the right page of the wanted diagnosis row using the same order the table renders.
// Returns null when the row isn't found.
export const getDiagnosisConflictPage = (diagnosisTableData, conflictKey) => {
  const index = orderDiagnosisRowsForDisplay(diagnosisTableData).findIndex((row) => row.key === conflictKey);
  return index >= 0 ? Math.floor(index / DIAGNOSIS_PAGE_SIZE) + 1 : null;
};

// Without a reducer function memoize looks at the object reference, which
// doesn't change as a result of property changes
export const buildPayloadFromDiagnosisTableData = _.memoize((diagnosisTableData) => {
  const { diagnosisInfo, activeDate, isActive, isPrimary } = diagnosisTableData;
  return {
    icd: diagnosisInfo.icd,
    activeDate,
    isActive,
    isPrimary
  };
}, JSON.stringify);
